<template>
    <div>
        <v-container  pt-7 px-6 ma-0 fluid>
        <v-row no-gutters>
            <v-col>
                <v-card style="border-radius: 20px;" class="white">
                    <v-card-title class="header-border pa-0 ma-0">
                        <v-row class="ml-0" no-gutters align="start" justify="start" style="width: 0px">
                            <v-col cols="auto">
                                <tabs-cadu
                                    :tabs="tabs"
                                    :currentTab="currentTab"
                                    :borderColor="greenColor"
                                    :textColor="greyColor"
                                    :textColorActive="greenColor"
                                />
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6" md="5" lg="3" class="pb-0 pt-0" :style="showLine">
                                <LeftRelatorios
                                    :index="tabIndex"
                                    @changeAll="changeAll"
                                />
                            </v-col>
                            <v-col cols="12" sm="12" md="8" lg="9" :class="$vuetify.breakpoint.xs ? 'pt-0 pb-10': 'pb-4'">
                                <RightRelatorios
                                    :tabName="tabNameSelected"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        </v-container>
        <error-modal
            v-model="error"
            :errObj="errObj"
        />
        <overlay-loading v-model="loadingOverlay"/>
    </div>
</template>

<script>
import LeftRelatorios from './LeftRelatorios'
import RightRelatorios from './RightRelatorios'

export default {
  components: {
    RightRelatorios,
    LeftRelatorios
  },
  data () {
    return {
      tabs: [
        {
          title: 'RELATÓRIOS',
          value: 'relatorios',
          disabled: false
        }
      ],
      currentTab: 'relatorios',
      tabIndex: 0,
      greenColor: this.$vuetify.theme.themes.light.primary1,
      greyColor: '#9E9E9E',
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      showError: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      role: '',
      tokenBearer: localStorage.getItem('tokenBearer'),
      showModalCancelar: false,
      showButtonCancelar: true,
      codigoUnimedVisualizada: this.unimedId,
      usuario: {},
      codigoMinhaUnimed: null,
      showModalAnexo: false,
      abaAnexo: '',
      showSuccessAnexo: false,
      anotherModal: false,
      linhaVertical: {
        'border-right': '1px solid #DEE2E6',
        'height': '100%'
      },
      error: false,
      loadingOverlay: false,
      showNovaUnimed: false,
      tabNameSelected: 'Relatórios'
    }
  },
  methods: {
    changeAll (obj) {
      const name = obj.tabName
      const index = obj.index
      this.tabIndex = index
      this.tabNameSelected = name
      this.$emit('name', this.tabNameSelected)
    }
  },
  computed: {
    showLine () {
      return !(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? this.linhaVertical : ''
    }
  }
}
</script>

<style lang="sass" scoped>
$corBorda: #E8E8E8

.header-border
  border-bottom: 2px solid $corBorda
</style>
